const initialState = {
    profileBundleInfo: null,
    bundles: [],
    selectedBundleKey: 0,
    comparisonData: [],
    cartResponse: null,
    installTimeSlots: null,
    installationDates: null,
    reserveinstallationdates: '',
    customtvoptions: [],
    isMM3qualified: false,
    showViewMoreButton : false,
    pegaBundleType: null,
    specialOffer: '',
    profileCart: null,
    disclaimer: '',
    dtmKeys: {
        planDTMSent: false,
        detailsDTMSent: false,
        reviewDTMSent: false
    },
    bundlesCallCompleted: false,
    cartAddCompleted: false,
    pegaPremiumChannelsInCart:[],
    premiumChannels:[],
    pegaPremiumChannelsHeader:null,
    disablePegaPremiumButton:true,
    isTileClickedMM3: false,
    selectedBundleId: '',
    isPegaFlow: false,
    isPegaPerksFlow: false,
    openFiosOverlay: false,
    expandTVPega: false,
    triggerPlansCall: 0,
    selectedTile: null,
    entrySeqTriggered: false,
    savings: [],
    comparisonFlag: false,
    compareIndex: '',
    compareTvPlans: [], 
    viewAllOptionsButtonClicked: false,
    togglePerkEc: false
}

function pega(state = initialState, action) {
    switch (action.type) {
        case 'BUNDLE_PLANS':
            return Object.assign({}, state, {
                profileBundleInfo: action.value.profileBundleInfo,
                bundles: action.value.bundles,
                customtvoptions: action.value.customtvoptions,
                isMM3qualified: action.value.isMM3qualified,
                bundlesCallCompleted: true,
                pegaBundleType: action.value?.profileBundleInfo?.profileBundleId
            })
        case 'SHOW_VIEWMORE_BTN':
            return Object.assign({}, state, {
                showViewMoreButton: action.value
            })
        case 'SCROLL_TO_PERKS_SECTION_EC':
            return  Object.assign({}, state, {
                togglePerkEc: action.value
            })
        case 'SELECTED_BUNDLE_KEY':
            return Object.assign({}, state, {
                selectedBundleKey: action.value
            })
        case 'COMPARISON_DATA':
            return Object.assign({}, state, {
                comparisonData: action.value
            })
        case 'UPDATE_CART_RESPONSE':
            return Object.assign({}, state, {
                cartResponse: action.value,
                cartAddCompleted: true
            })
        case 'INSTALLATION_DATES':
            return Object.assign({}, state, {
                installationDates: action.value
            })
        case 'UPDATE_TIME_SLOTS':
            return Object.assign({}, state, {
                installTimeSlots: action.value,
                selInstallTimeSlot: action.value[0].displayTime,
                selInstallTimeSlotReserved: action.value[0].reserveTime
            })
        case 'RESERVE_INSTALLATION_DATES':
            return Object.assign({}, state, {
                reserveinstallationdates: action.value,
            })
        case 'SPECIAL_OFFER':
            return Object.assign({}, state, {
                specialOffer: action.value
            })
        case 'PROFILE_CART':
            return Object.assign({}, state, {
                profileCart: action.value
            })
        case "DISCLAIMER":
            return Object.assign({}, state, {
                disclaimer: action.value
            })
        case 'SET_DTM_VALUES':
            let dtmKeys = state.dtmKeys;
            action.value == 'renewalbundleplans' ? dtmKeys.planDTMSent = true : action.value == 'bundledetails' ? dtmKeys.detailsDTMSent = true : action.value == 'review' ? dtmKeys.reviewDTMSent = true : '';
            return Object.assign({}, state, {
                dtmKeys: dtmKeys
            })
        case 'PEGA_PREMIUM_CHANNELS_IN_CART':
            return{
                ...state,
                pegaPremiumChannelsInCart:action.value
            }
        case 'STORE_PREMIUM_CHANNELS':
            return{
                ...state,
                premiumChannels:action.value
            }
        case 'SET_PREMIUM_CHANNELS_HEADER':
            return{
                ...state,
                pegaPremiumChannelsHeader:action.value
            }        
        case 'DISABLE_PEGA_PREMIUM_CONTINUE_BUTTON':
            return{
                ...state,
                disablePegaPremiumButton:action.value
            }
        case 'IS_TILESELECTED_MM3':
            return{
                ...state,
                isTileClickedMM3:action.value
            }
        case 'SELECTED_BUNDLE_ID':
            return{
                ...state,
                selectedBundleId:action.value
            }
        case 'PEGA_FLOW':
            return{
                ...state,
                isPegaFlow:action.value
            }
        case 'OPEN_FIOS_MODAL':
            return{
                ...state,
                openFiosOverlay:action.value
            }
        case 'EXPAND_TV_PEGA':
            return{
                ...state,
                expandTVPega:action.value
            }
        case 'TRIGGER_PLANS_CALL':
            return{
                ...state,
                triggerPlansCall:action.value
            }
        case 'UPDATE_SELECTED_TILE':
            return{
                ...state,
                selectedTile:action.value
            }
        case 'VIEW_ALL_OPTIONS_BUTTON_CLICKED' :
            return{
                ...state,
                viewAllOptionsButtonClicked:action.value
            }    
        case 'ENTRY_SEQ_TRIGGERED':
            return{
                ...state,
                entrySeqTriggered:action.value
            }
        case 'ALL_SAVINGS_DETAILS':
            return{
                ...state,
                savings: action.value
            }
        case 'UPDATE_COMPARISON_FLAG':
            return{
                ...state,
                comparisonFlag: action.value
            }
        case 'UPDATE_COMPARE_INDEX':
            return{
                ...state,
                compareIndex: action.value
            }
        case 'UPDATE_COMPARE_TV_PLANS':
            return{
                ...state,
                compareTvPlans: action.value
            }
        case "SET_PERKS_FROM_PEGA": {
            return {
                ...state,
                isPegaPerksFlow: action?.value ? true : false,
            };
        }
        default:
            return state
    }
}

export default pega